import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";

const NEXT_STEP = "/coach?start=" + encodeURIComponent("I just finished my 7-day sprint! What's my next step?");

export const SprintDoneCard = ({ isPremium }) => (
  <div className="mt-4 p-5 border border-[#FD0F10]/50 bg-[#FD0F10]/5 rounded-lg" data-testid="sprint-done-card">
    <Trophy size={20} className="text-[#FD0F10]" />
    {isPremium ? (
      <>
        <div className="font-display text-xl font-black text-white mt-2" data-testid="sprint-done-title">Congratulations! You finished your 7-day sprint.</div>
        <p className="text-sm text-gray-300 mt-1">That's real momentum. Your coach is ready with your next step.</p>
        <Link to={NEXT_STEP} className="mt-4 inline-flex items-center gap-2 hero-accent text-white font-bold px-5 py-3 rounded" data-testid="sprint-done-next-step">
          Get my next step <ArrowRight size={16} />
        </Link>
      </>
    ) : (
      <>
        <p className="text-white font-bold mt-2" data-testid="sprint-done-title">You finished your 7-day sprint! Upgrade to Pro to keep going with your coach. Get help growing your side hustle, creating content, and taking your next steps.</p>
        <Link to="/pro" className="mt-4 inline-flex items-center gap-2 hero-accent text-white font-bold px-5 py-3 rounded" data-testid="sprint-done-upgrade">
          Upgrade to Pro <ArrowRight size={16} />
        </Link>
      </>
    )}
  </div>
);
